import { definePrivacyFooterElements } from "~/src/customElements/privacyFooter"

definePrivacyFooterElements()
